import React, {useState, useEffect} from 'react'
import CloseButton from 'react-bootstrap/CloseButton';
import { useNavigate } from 'react-router-dom';
import fetchData from '../../function/fetchData';
import { Container, Row, Col } from 'react-bootstrap';
import formatDateTime from '../../function/formatDateTime';

const DriverRoadHistory = ({setShowStatistics, server, token, datetimeStart, datetimeEnd, selectedDriverId, getName}) => {

    const navigate = useNavigate();
    const [data, setData] = useState([])
    const driverName = selectedDriverId ? getName(selectedDriverId) : null



    // Spočítá total
    const [totalTel , setTotalTel] = useState(0)
    const [totalApp, setTotalApp] = useState(0)
    const [totalLong, setTotalLong] = useState(0)

    useEffect( ()=> {
        let countApp = 0
        let countTel = 0
        let countLong = 0

        data.forEach( one => {
            console.log(parseInt(one.countTel))
            countTel += one.countTel ? parseInt(one.countTel) : 0
            countApp += one.countTel ? parseInt(one.countApp) : 0
            countLong += one.countTel ? parseInt(one.countLong) : 0
        })

        setTotalApp(countApp)
        setTotalTel(countTel)
        setTotalLong(countLong)
    })



    // Získá data ze serveru
    useEffect( ()=> {
        if(token){
            fetchData(server + "api2/adminScheduleController.php", {token: token, action: "GET_DRIVERS_SCHEDULE_LOG", selectedDriverId ,datetimeStart, datetimeEnd })
            .then( (res) => {
                if(res.status === "OK"){
                    console.log(res)
                    setData(res.payload.driverHistory)
                } else {
                    alert('chyba spojení, zkuste to později')
                }
            } )
        }

    }, [datetimeStart, datetimeEnd, selectedDriverId])
    
    return (
        <div>
            {/* TOP */}
             <div style={{position: 'fixed', background: '#eee', top:0, width: '100%', flexDirection: 'row', display: 'flex' , justifyContent: 'space-between', alignItems: 'center', padding: 16}}>
                <div style={{display:'flex', gap: 10, alignItems: 'center', fontWeight: 'bold', fontSize: 20}}>
                    {selectedDriverId ? 'Historie řidiče: '+ driverName: 'Historie jízd řidičů za posledních' } od: {formatDateTime(datetimeStart)} do: {formatDateTime(datetimeEnd)}
                </div>
               
                <CloseButton onClick={()=> setShowStatistics(false) }/>
            </div>

             {/* BODY */}
                    <Container style={{flexDirection: 'column', flex: 1, margin: 'auto', paddingTop: 80, paddingBottom: 50}}>
                        {data.map( one => {
                            return <div style={{flex: 1, flexDirection: 'column', borderBottom: '1px solid #eeee', padding: 8, margin: 'auto',  marginTop: 8, width : '100%'}} key={one.id}>
                                        <Row key={one.id} >
                                            <Col xs={5}>
                                                <strong>Řidič: {one.nick} </strong>
                                            </Col>
                                            <Col xs={2} style={{color: 'grey'}}>
                                                Počet telefonů
                                            </Col>
                                            <Col xs={2} style={{color: 'grey'}}>
                                                Počet app
                                            </Col>
                                            <Col xs={2} style={{color: 'grey'}}>
                                                Počet dálkových jízd
                                            </Col>
                                    
                                        </Row>
                                        <Row>
                                            <Col xs={5}>
                                                <strong>Začátek: {formatDateTime(one.start)} -  Konec: {formatDateTime(one.end)}</strong>
                                            </Col>
                                            <Col xs={2}>
                                                <strong>{one.countTel}</strong>
                                            </Col>
                                            <Col xs={2}>
                                                <strong>{one.countApp}</strong>
                                            </Col>
                                            <Col xs={2}>
                                                <strong>{one.countLong}</strong>
                                            </Col>
                                        </Row>
                        
                                        <Row>
                                            <Col>
                                                {one.note}
                                            </Col>
                                        </Row>
                                </div>
                        })}

                    </Container>
            {/* FOOTER */}
            <div style={{position: 'fixed', background: '#eee', bottom:0, width: '100%'}}>
            
                    <Row>
                        <Col xs={5}>
                           
                        </Col>
                        <Col xs={2} style={{color: 'grey'}}>
                            Celkem Telefonů: <strong style={{color: 'black'}}>{totalTel}</strong>
                        </Col>
                        <Col xs={2} style={{color: 'grey'}}>
                            Celkem App <strong style={{color: 'black'}}>{totalApp}</strong>
                        </Col>
                        <Col xs={2} style={{color: 'grey'}}>
                            Celkem dálkových <strong style={{color: 'black'}}>{totalLong}</strong>
                        </Col>
                                    
                     </Row>
            
            </div>
                    
               
        </div>
    )
}

export default DriverRoadHistory
